import { navItems } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-100 pt-14 md:pt-16 pb-8">
      <div className="w-full px-4 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl" />
              </span>
              <span className="font-heading text-2xl font-bold text-foreground-950">黑料热点</span>
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed mt-5 max-w-sm">
              汇集黑料热点网友评论与站队情况，展示舆论反转、态度变化与公关动作。不爆料、不站队，只帮你判断风向再开口。
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-950 tracking-wide">
              <a href="#top" className="cursor-pointer">站内导航</a>
            </h4>
            <div className="flex flex-col gap-3 mt-5">
              {navItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  className="text-sm text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-bold text-foreground-950 tracking-wide">
              <a href="#faq" className="cursor-pointer">使用提示</a>
            </h4>
            <p className="text-sm text-foreground-700 leading-relaxed mt-5">
              站内展示的比例与时间线均来自公开讨论的粗略汇总，仅用于反映大致风向，不构成对任何一方的定论。请勿据此对具体个人进行人身攻击。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-primary-600">
                <i className="ri-shield-check-line" />
              </span>
              <span className="text-xs text-foreground-600 font-label">理性吃瓜 · 先看风向</span>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-300/60 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">© 2026 黑料热点 · 仅为舆论风向信息展示</p>
          <p className="text-xs text-foreground-500">站内内容为演示数据</p>
        </div>
      </div>
    </footer>
  );
}